var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMastersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 2.063h-11a1.375 1.375 0 0 0-1.375 1.374v15.126A1.375 1.375 0 0 0 5.5 19.938h11a1.375 1.375 0 0 0 1.375-1.375V3.438A1.375 1.375 0 0 0 16.5 2.062zm0 1.374v4.126h-11V3.438h11zm-11 9.626V8.936h11v4.126h-11zm0 5.5v-4.125h11v4.124h-11z",
    fill: "#707070"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.563 6.188a.687.687 0 1 0 0-1.375.687.687 0 0 0 0 1.375zM7.563 11.688a.687.687 0 1 0 0-1.375.687.687 0 0 0 0 1.374zM7.563 17.188a.687.687 0 1 0 0-1.375.687.687 0 0 0 0 1.374z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastersIcon);
export default __webpack_public_path__ + "static/media/mastersIcon.c5409914003dcac9cc90d503eb1bf63e.svg";
export { ForwardRef as ReactComponent };